"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The response of TopicUpdate ADD_AND_SET_TOPIC service
 */
var JsonPatchResult = /** @class */ (function () {
    /**
     * Create a new AddAndSetTopicRequest instance
     *
     * @param result  topic creation result
     */
    function JsonPatchResult(failedOperation) {
        this.failedOperation = failedOperation < 0 ? undefined : failedOperation;
    }
    return JsonPatchResult;
}());
exports.JsonPatchResult = JsonPatchResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/json-patch-result.js
// module id = 1410
// module chunks = 1